module.exports = __webpack_public_path__ + "images/913bc2467b308d609820a10b6e0600b20d32a40c2f10ce4cce80cb77c9d53bff.svg";